"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
function Pagination(_a) {
    var loading = _a.loading, paginate = _a.paginate, className = _a.className, currentPage = _a.currentPage, isNextDisabled = _a.isNextDisabled, isPreviousDisabled = _a.isPreviousDisabled;
    return (react_1.default.createElement("div", { className: "ng-table-pager pager eva-pagination ".concat(className) },
        react_1.default.createElement("ul", { className: "pagination" },
            react_1.default.createElement("li", { className: isPreviousDisabled || loading ? 'disabled' : '' },
                react_1.default.createElement("a", { onClick: function () {
                        var newPage = currentPage ? currentPage - 1 : 0;
                        paginate(newPage);
                    }, className: "implioicons-arrow-1-left eva-pagination-arrow-icons" })),
            react_1.default.createElement("li", { className: isNextDisabled || loading ? 'disabled' : '' },
                react_1.default.createElement("a", { onClick: function () {
                        var newPage = currentPage + 1;
                        paginate(newPage);
                    }, className: "implioicons-arrow-1-right eva-pagination-arrow-icons" })))));
}
exports.default = Pagination;
